import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { ArrowBigUp, ArrowBigDown } from "lucide-react";
import { api, formatErr } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function VoteButtons({ thread, vertical = true }) {
  const { user } = useAuth();
  const nav = useNavigate();
  const [score, setScore] = useState(thread.score);
  const [mine, setMine] = useState(thread.my_vote);

  const vote = async (e, v) => {
    e.preventDefault();
    e.stopPropagation();
    if (!user) return nav("/login");
    const value = mine === v ? 0 : v;
    try {
      const { data } = await api.post(`/threads/${thread.id}/vote`, { value });
      setScore(data.score);
      setMine(data.my_vote);
    } catch (err) { toast.error(formatErr(err)); }
  };

  return (
    <div className={`flex items-center gap-1 ${vertical ? "flex-col" : ""}`}>
      <button onClick={(e) => vote(e, 1)} data-testid="community-upvote-btn" className={`rounded-lg p-1 transition-colors hover:bg-[#FF2E4D]/10 ${mine === 1 ? "text-[#FF2E4D]" : "text-gray-500"}`}>
        <ArrowBigUp className={`h-6 w-6 ${mine === 1 ? "fill-[#FF2E4D]" : ""}`} />
      </button>
      <span className="font-display text-sm font-semibold" data-testid="thread-score">{score}</span>
      <button onClick={(e) => vote(e, -1)} data-testid="community-downvote-btn" className={`rounded-lg p-1 transition-colors hover:bg-white/5 ${mine === -1 ? "text-gray-300" : "text-gray-500"}`}>
        <ArrowBigDown className={`h-6 w-6 ${mine === -1 ? "fill-gray-300" : ""}`} />
      </button>
    </div>
  );
}
